import React from 'react';
import { withRouter } from 'react-router-dom';

class EditarCentro extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            id: "",
            nome: "",
            banco: "",
            agencia: "",
            contaBanco: "",
            saldoInicial: "",
            saldoAtual: "",
            saldoInicialInvestimento: "",
            saldoInvestimento: "",
            bancoSec: "",
            agenciaSec: "",
            contaBancoSec: "",
            saldoInicialSec: "0,00",
            saldoAtualSec: "",
            ativo: "",
            bancoSecConf: "",
            saldoInicialInvestimentoSec: "0,00",
            saldoInvestimentoSec: "",
        };

        this.changeNome = this.changeNome.bind(this);
        this.changeBanco = this.changeBanco.bind(this);
        this.changeAgencia = this.changeAgencia.bind(this);
        this.changeContaBanco = this.changeContaBanco.bind(this);
        this.changeBancoSec = this.changeBancoSec.bind(this);
        this.changeAgenciaSec = this.changeAgenciaSec.bind(this);
        this.changeContaBancoSec = this.changeContaBancoSec.bind(this);
        this.changeSaldoInicialSec = this.changeSaldoInicialSec.bind(this);
        this.changeSaldoInicialInvestimentoSec = this.changeSaldoInicialInvestimentoSec.bind(this);
        this.changeAtivo = this.changeAtivo.bind(this);
        this.salvar = this.salvar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    moneyUnmask(str_val) {

        let res = "";
        let vec = str_val.split(",");

        for (let i = 0; i < vec[0].length; i++) {

            if (vec[0][i] !== ".") {
                res = res + vec[0][i];
            }

        }

        res = res + "." + vec[1];
        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return this.moneyUnmask(s);
    }

    changeNome(e) {
        this.setState({ nome: e.target.value });
    }

    changeBanco(e) {
        this.setState({ banco: e.target.value });
    }

    changeAgencia(e) {
        this.setState({ agencia: e.target.value });
    }

    changeContaBanco(e) {
        this.setState({ contaBanco: e.target.value });
    }

    changeBancoSec(e) {
        this.setState({ bancoSec: e.target.value });
    }

    changeAgenciaSec(e) {
        this.setState({ agenciaSec: e.target.value });
    }

    changeContaBancoSec(e) {
        this.setState({ contaBancoSec: e.target.value });
    }

    changeAtivo(e) {
        if (e.target.value === "ativo") this.setState({ ativo: true });
        else this.setState({ ativo: false });
    }

    changeSaldoInicialSec(e) {

        let sval = "";
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (e.target.value !== "-0,0") {

            for (let i = 0; i < e.target.value.length; i++) {

                if (re.test(e.target.value[i])) {

                    if (e.target.value[i] === "-") neg = true;
                    else sval = sval + e.target.value[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        this.setState({ saldoInicialSec: res });

    }

    changeSaldoInicialInvestimentoSec(e) {

        let sval = "";
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (e.target.value !== "-0,0") {

            for (let i = 0; i < e.target.value.length; i++) {

                if (re.test(e.target.value[i])) {

                    if (e.target.value[i] === "-") neg = true;
                    else sval = sval + e.target.value[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        this.setState({ saldoInicialInvestimentoSec: res });

    }

    salvar() {

        this.setState({ disabled: true });

        if (this.state.nome === "") {

            this.props.errMsgHandler("Por favor, informe o nome do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.banco === "") {

            this.props.errMsgHandler("Por favor, informe qual é o banco do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.agencia === "") {

            this.props.errMsgHandler("Por favor, informe qual é a agência bancária do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.contaBanco === "") {

            this.props.errMsgHandler("Por favor, informe qual é a conta bancária do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.bancoSec !== "" && this.state.agenciaSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é a agência secundária do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.bancoSec !== "" && this.state.contaBancoSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é a conta bancária secundária do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.agenciaSec !== "" && this.state.bancoSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é o banco secundário do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.agenciaSec !== "" && this.state.contaBancoSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é a conta bancária secundária do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.contaBancoSec !== "" && this.state.bancoSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é o banco secundário do centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.contaBancoSec !== "" && this.state.agenciaSec === "") {

            this.props.errMsgHandler("Por favor, informe qual é a agência secundária do centro de custo.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let obj = {
                "id": this.state.id,
                "nome": this.state.nome,
                "banco": this.state.banco,
                "agencia": this.state.agencia,
                "conta_banco": this.state.contaBanco,
                "saldo_inicial": this.state.saldoInicial,
                "saldo_atual": this.state.saldoAtual,
                "saldo_inicial_investimento": this.state.saldoInicialInvestimento,
                "saldo_investimento": this.state.saldoInvestimento,
                "banco_sec": "",
                "agencia_sec": "",
                "conta_banco_sec": "",
                "saldo_inicial_sec": null,
                "saldo_atual_sec": null,
                "saldo_inicial_investimento_sec": null,
                "saldo_investimento_sec": null,
                "ativo": this.state.ativo
            };

            if (this.state.bancoSec !== "") {

                obj.banco_sec = this.state.bancoSec;
                obj.agencia_sec = this.state.agenciaSec;
                obj.conta_banco_sec = this.state.contaBancoSec;
                obj.saldo_inicial_sec = this.desformatarValor(this.state.saldoInicialSec);
                obj.saldo_inicial_investimento_sec = this.desformatarValor(this.state.saldoInicialInvestimentoSec);

                if (this.state.saldoAtualSec === "" || this.state.saldoAtualSec === null) {
                    obj.saldo_atual_sec = this.desformatarValor(this.state.saldoInicialSec);
                } else {
                    obj.saldo_atual_sec = this.state.saldoAtualSec;
                }

                if (obj.saldo_inicial_sec === "-0.00") {
                    obj.saldo_inicial_sec = "0.00";
                    obj.saldo_atual_sec = "0.00";
                }

                if (this.state.saldoInvestimentoSec === "" || this.state.saldoInvestimentoSec === null) {
                    obj.saldo_investimento_sec = this.desformatarValor(this.state.saldoInicialInvestimentoSec);
                } else {
                    obj.saldo_investimento_sec = this.state.saldoInvestimentoSec;
                }

                if (obj.saldo_inicial_investimento_sec === "-0.00") {
                    obj.saldo_inicial_investimento_sec = "0.00";
                    obj.saldo_investimento_sec = "0.00";
                }

            }

            fetch("/api/centro/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Informações do centro de custo salvas com sucesso.");
                    this.props.history.push("/centros");

                }

            });

        }

    }

    cancelar() {

        this.props.errMsgHandler("");

        let obj = {
            id: this.props.location.state.id,
        }

        this.props.history.push({
            pathname: "/visualizarcentro",
            state: { row: obj }
        });

    }

    componentDidMount() {

        if (localStorage.roleCentros !== "escrever") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/centros";
        }

        this.setState({ id: this.props.location.state.id });
        this.setState({ nome: this.props.location.state.nome });
        this.setState({ banco: this.props.location.state.banco });
        this.setState({ agencia: this.props.location.state.agencia });
        this.setState({ contaBanco: this.props.location.state.contaBanco });
        this.setState({ saldoInicial: this.props.location.state.saldoInicial });
        this.setState({ saldoAtual: this.props.location.state.saldoAtual });
        this.setState({ saldoInicialInvestimento: this.props.location.state.saldoInicialInvestimento });
        this.setState({ saldoInvestimento: this.props.location.state.saldoInvestimento });
        this.setState({ bancoSec: this.props.location.state.bancoSec });
        this.setState({ agenciaSec: this.props.location.state.agenciaSec });
        this.setState({ contaBancoSec: this.props.location.state.contaBancoSec });

        let saldoInicialSec = this.props.location.state.saldoInicialSec;
        let saldoInicialInvestimentoSec = this.props.location.state.saldoInicialInvestimentoSec;

        if (saldoInicialSec !== null) {
            this.setState({ saldoInicialSec: this.props.location.state.saldoInicialSec });
            this.setState({ saldoAtualSec: this.props.location.state.saldoAtualSec });
        }

        if (saldoInicialInvestimentoSec !== null) {
            this.setState({ saldoInicialInvestimentoSec: this.props.location.state.saldoInicialInvestimentoSec });
            this.setState({ saldoInvestimentoSec: this.props.location.state.saldoInvestimentoSec });
        }

        if (this.props.location.state.ativo === 1) this.setState({ ativo: true });
        else this.setState({ ativo: false });

        this.setState({ bancoSecConf: this.props.location.state.bancoSec });

    }

    render() {
        return(
            <div>
                <h1 id="editar-centro-titulo">Editar Centro de Custo</h1><br /><br />
                <p id="editar-centro-obrigatorios">
                    * Campos obrigatórios. Caso um dos campos não obrigatórios (Banco Secundário, Agência Secundária e Conta Bancária) <br />for preenchido, será obrigatório o preenchimento dos demais.
                </p><br />
                <form id="editar-centro-form">
                    <input type="text"
                        placeholder="Nome*"
                        value={ this.state.nome }
                        onChange={ this.changeNome } /><br />
                    <input type="text"
                        placeholder="Banco*"
                        value={ this.state.banco }
                        onChange={ this.changeBanco } /><br />
                    <input type="text"
                        placeholder="Agência*"
                        value={ this.state.agencia }
                        onChange={ this.changeAgencia } /><br />
                    <input type="text"
                        placeholder="Conta Bancária*"
                        value={ this.state.contaBanco }
                        onChange={ this.changeContaBanco } /><br />
                    <input type="text"
                        placeholder="Banco Secundário"
                        value={ this.state.bancoSec }
                        onChange={ this.changeBancoSec } /><br />
                    <input type="text"
                        placeholder="Agência Secundária"
                        value={ this.state.agenciaSec }
                        onChange={ this.changeAgenciaSec } /><br />
                    <input type="text"
                        placeholder="Conta Bancária Secundária"
                        value={ this.state.contaBancoSec }
                        onChange={ this.changeContaBancoSec } /><br />
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <span Class="cadcentro-somente-numeros">
                            <b>Saldo Inicial Secundário:</b>
                        </span> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <input type="text"
                            placeholder="Saldo Inicial Secundário (R$)"
                            value={ this.state.saldoInicialSec }
                            onChange={ this.changeSaldoInicialSec } /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <span Class="cadcentro-somente-numeros">
                            (Somente valores númericos. Ex: 10, 1,5, ...)
                        </span> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <span Class="cadcentro-somente-numeros">
                            <b>Saldo Inicial de Investimento Secundário:</b>
                        </span> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <input type="text"
                            placeholder="Saldo Inicial de Investimento Secundário (R$)"
                            value={ this.state.saldoInicialInvestimentoSec }
                            onChange={ this.changeSaldoInicialInvestimentoSec } /> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) &&
                        <span Class="cadcentro-somente-numeros">
                            (Somente valores númericos. Ex: 10, 1,5, ...)
                        </span> }
                    { (this.state.bancoSecConf === "" || this.state.bancoSecConf === null) && <br /> }
                    <ul class="edcentro-status-lst">
                        <li>
                            <b>Status: </b>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="ativo"
                                    checked={ this.state.ativo === true }
                                    onChange={ this.changeAtivo } /> Ativo
                            </label>
                            <label>
                                <input type="radio"
                                    name="ativo"
                                    value="inativo"
                                    checked={ this.state.ativo === false }
                                    onChange={ this.changeAtivo } /> Inativo
                            </label>
                        </li>
                    </ul>
                    <br /><br />
                    <button type="button"
                        id="edcentro-salvar-btn"
                        onClick={ this.salvar }
                        disabled={ this.state.disabled }>Salvar</button>
                    <button type="button" id="edcentro-cancelar-btn" onClick={ this.cancelar }>
                        Cancelar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default withRouter(EditarCentro);

